import { defineMessages } from 'react-intl'

export default defineMessages({
  emailPlaceholder: {
    id: 'signup.emailPlaceholder',
    defaultMessage: 'Email'
  },
  passwordPlaceholder: {
    id: 'signup.passwordPlaceholder',
    defaultMessage: 'Password'
  },
  confirmPasswordPlaceholder: {
    id: 'signup.confirmPasswordPlaceholder',
    defaultMessage: 'Confirm Password'
  },
  signupButton: {
    id: 'signup.signupButton',
    defaultMessage: 'Sign up'
  },
  loginLink: {
    id: 'signup.loginLink',
    defaultMessage: 'Already have an account? Login here'
  },
  welcomePageTitle: {
    id: 'signup.welcomePageTitle',
    defaultMessage: 'Create an Account'
  },
  welcomePageSubtitle: {
    id: 'signup.welcomePageSubtitle',
    defaultMessage: 'Please enter your details to sign up.'
  },
  googleSignupButton: {
    id: 'signup.googleSignupButton',
    defaultMessage: 'Sign up with Google'
  },
  welcomeTitle: {
    id: 'signup.welcomeTitle',
    defaultMessage: 'Welcome!'
  },
  welcomeDescription: {
    id: 'signup.welcomeDescription',
    defaultMessage: 'You have successfully logged in'
  },
  errorTitle: {
    id: 'signup.errorTitle',
    defaultMessage: 'Something wrong happened...'
  },
  passwordTooShort: {
    id: 'signup.passwordTooShort',
    defaultMessage: 'Password must be at least 6 characters long'
  },
  passwordMismatch: {
    id: 'signup.passwordMismatch',
    defaultMessage: 'Passwords do not match'
  }
})
